<template>
  <div class="support-entries-component">
    <div v-if="routeDocHref" class="text-center pa-1">
      <DocumentationButton :path="routeDocHref">
        Page documentation
      </DocumentationButton>
    </div>
    <VList>
      <VListTile @click="onSearchDoc">
        <VListTileAvatar>
          <KmIcon name="km-icon-search" />
        </VListTileAvatar>
        <VListTileTitle class="doc-search-tile-title">
          Search documentation
        </VListTileTitle>
      </VListTile>

      <VListTile v-if="showRestoreAppcues" @click="restoreAppcues">
        <VListTileAvatar>
          <KmIcon name="km-icon-check" />
        </VListTileAvatar>
        <VListTileTitle class="text--text">
          Restore onboarding
        </VListTileTitle>
      </VListTile>

      <VListTile href="https://github.com/keymetrics/pm2-plus-tech-questions" target="_blank">
        <VListTileAvatar>
          <KmIcon name="km-icon-team" />
        </VListTileAvatar>
        <VListTileTitle class="text--text">
          Community support
        </VListTileTitle>
      </VListTile>

      <VListTile v-if="hasPremiumSupport && !isDedicated" @click="onOpenZendesk">
        <VListTileAvatar>
          <KmIcon name="km-icon-support" />
        </VListTileAvatar>
        <VListTileTitle class="text--text">
          Open a support ticket
        </VListTileTitle>
      </VListTile>

      <VListTile v-if="isDedicated" href="mailto:tech@pm2.io?subject=[Dedicated support]">
        <VListTileAvatar>
          <KmIcon name="km-icon-support" />
        </VListTileAvatar>
        <VListTileTitle class="text--text">
          Contact PM2 tech team
        </VListTileTitle>
      </VListTile>
    </VList>
  </div>
</template>

<script>
import KmIcon from '@/components/KmIcon'
import DocumentationButton from '@/components/DocumentationButton'
import { SHOW_SUPPORT_POPUP, SHOW_FEEDBACK_POPUP, SET_IS_PORTAL_OPEN } from '@/store/mutations'

export default {
  name: 'SupportEntries',

  components: {
    KmIcon,
    DocumentationButton,
  },

  data() {
    return {
      showRestoreAppcues: Boolean(window.Appcues && !document.querySelector('.appcues')),
    }
  },

  computed: {
    routeDocHref() {
      return this.$store.state.route.meta.doc
    },

    hasPremiumSupport() {
      const plan = this.$store.getters.currentPlan
      return plan && plan.is_premium
    },

    isDedicated() {
      return this.$store.getters.isDedicated
    },
  },

  methods: {
    onSearchDoc() {
      this.$store.commit(SET_IS_PORTAL_OPEN, { isOpen: true, initialInput: 'doc ' })
    },

    onOpenZendesk() {
      this.$store.commit(SHOW_SUPPORT_POPUP, { show: true })
      this.$emit('close-nav-bar')
    },

    onOpenFeedbackPopup() {
      this.$store.commit(SHOW_FEEDBACK_POPUP, { show: true })
      this.$emit('close-nav-bar')
    },

    restoreAppcues() {
      window.Appcues.show('-LKbQwAl0w9iStSSSJWZ')
      this.showRestoreAppcues = false
    },
  },
}
</script>

<style lang="postcss" scoped></style>
